import { makeAutoObservable } from "mobx";
import { PModifierItemInstanceId } from "./PModifierItemInstanceId";
import { PPrice } from "./PPrice";
import { getDepositIcon } from "./PDepositIcon";
export class PModifierItemInstanceCreator {
    constructor(params) {
        this.instanceId = new PModifierItemInstanceId();
        this.domain = params.domain;
        this.behaviour = params.behaviour;
        this.modifierItemType = params.modifierItemType;
        this.packagingFeeType = params.packagingFeeType;
        this.localizationProvider = params.localizationProvider;
        this.modifierItemInstancePriceService =
            params.modifierItemInstancePriceService;
        this.modifierItemInstanceAvailabilityService =
            params.modifierItemInstanceAvailabilityService;
        this.onChange = params.onChange;
        this.creatorScopeProvider = params.creatorScopeProvider;
        makeAutoObservable(this);
    }
    /**
     * The idea of hiding unavailable modifiers makes lot of troubles in code.
     * It fiters out modifiers in Cart and should work only in creator.
     * Eg. Default value in fulfillment method is DineIn so during refreshing page we use ProductInstanceCreator
     * which filters out modifiers which are not available in DineIn fulfilment method.
     **/
    get isVisible() {
        return this.itemAvailability.isAvailable.isPossible;
    }
    get typeId() {
        return this.modifierItemType.id;
    }
    select() {
        this.domain.select();
        this.onChange();
    }
    get isSelected() {
        return this.domain.isSelected;
    }
    setSelected(selected) {
        this.domain.setSelected(selected);
        this.onChange();
    }
    get itemQuantity() {
        return this.domain.quantity.value;
    }
    get unitPrice() {
        const itemPrice = this.modifierItemInstancePriceService.price(this.domain.modifierItemInstance, this.creatorScopeProvider.parameterSet);
        const p = new PPrice(this.localizationProvider, itemPrice.spectrum)
            .priceValue;
        return p === null ? "" : ` (${p})`;
    }
    get canDecrement() {
        return this.domain.canDecrement;
    }
    get canIncrement() {
        return this.domain.canIncrement;
    }
    decrement() {
        this.domain.decrement();
        this.onChange();
    }
    increment() {
        this.domain.increment();
        this.onChange();
    }
    get itemAvailability() {
        return this.modifierItemInstanceAvailabilityService.unitAvailability(this.domain.modifierItemInstance, this.creatorScopeProvider.parameterSet);
    }
    get name() {
        var _a, _b;
        const baseName = this.modifierItemType.name;
        const packagingName = (_b = (_a = this.packagingFeeType) === null || _a === void 0 ? void 0 : _a.name.value) !== null && _b !== void 0 ? _b : null;
        return packagingName !== null ? `${baseName} - ${packagingName}` : baseName;
    }
    get photo() {
        return this.modifierItemType.photo;
    }
    get depositIcon() {
        var _a, _b;
        const deposit = (_b = (_a = this.packagingFeeType) === null || _a === void 0 ? void 0 : _a.deposit) !== null && _b !== void 0 ? _b : null;
        return deposit !== null ? getDepositIcon(deposit) : null;
    }
}
